export default __webpack_public_path__ + "static/media/ijac_logo.e72b70a6.png";